import React from "react";
import { toUpper } from "lodash";
import { Box, Flex } from "../../components/Flex";
import { Content } from "../../components/Layout";
import { Paragraph, Title } from "../../components/Text";
import { CloseIcon } from "../../icons/CloseIcon";
import { Scrollbar } from "../../components/Scrollbar";
import { fixPackageSize, formatDate } from "../../utils";
import { Button } from "../../components/Button";
import { RemoveIcon } from "../../icons/RemoveIcon";


const UploadDetails = ({ tab, data, onClose, renderFieldContent, shcWrite, removeUpload, loading }) => {
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    const fields = {
        shc: {
            main: [
                { label: "Upload reference", attr: "uploadRef"},
                { label: "File name", attr: "fileName"},
                { label: "Node name", attr: "nodeName"},
                { label: "File size", attr: "fileSize", render: (d) => fixPackageSize(d) },
                { label: "Start datetime", attr: "startTime", render: (d) => formatDate(d, dateFormat) },
                { label: "Stop datetime", attr: "stopTime", render: (d) => formatDate(d, dateFormat) },
            ],
            box: [
                { label: "Uploaded By", attr: "uploadedBy" },
                { label: "Email", attr: "email" },
                { label: "Upload Datetime", attr: "uploadDatetime", render: d => formatDate(d, dateFormat) }
            ]
        }
    };


    return(
        Object.keys(fields).includes(tab)
            ? <Content background="#FFFFFF" gap={{ bottom: 18 }}>
                <Flex width="100%" justify="space-between" margin={{ bottom: "24px"}}>
                    <Title h4>{toUpper(tab)} upload details</Title>
                    <CloseIcon onClick={onClose} />
                </Flex>
                <Flex height="calc(100% - 108px)">
                    <Scrollbar>
                        <Flex justify="space-between" gap={{ right: 18 }}>
                            <Flex direction="column" gap={{ bottom: 16 }}>
                                {renderFieldContent(fields[tab].main, data)}
                            </Flex>
                            <Box flatten background="#F0F4FB" gap={{ bottom: 8 }}>
                                {renderFieldContent(fields[tab].box, data)}
                            </Box>
                        </Flex>
                    </Scrollbar>
                </Flex>
                {shcWrite &&
                <Flex>
                    <Button danger
                        onClick={() => removeUpload({
                            content: <Paragraph>Are you sure you want to delete the <b>{data.fileName}</b> and all its data?</Paragraph>,
                            id: data.uploadRef
                        })}
                        disabled={loading}
                    >
                        <RemoveIcon size={20} />
                        Delete
                    </Button>
                </Flex>}
            </Content>
            : null
    )
};

export { UploadDetails };